module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "mdl-layout__header mdl-layout__header--transparent"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('span', {
    staticClass: "mdl-layout-title"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Vue")])], 1), _vm._v(" "), (_vm.loggedIn) ? _c('span', {
    staticClass: "welcome-user"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('welcome', {
        name: _vm.user.username
      }))
    }
  }), _vm._v(" ("), _c('router-link', {
    attrs: {
      "to": {
        name: 'logout'
      }
    }
  }, [_vm._v("sair")]), _vm._v(")\n    ")], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  }), _vm._v(" "), _c('nav', {
    staticClass: "mdl-navigation mdl-cell--hide-phone"
  }, _vm._l((_vm.nav), function(item) {
    return _c('router-link', {
      staticClass: "mdl-navigation__link",
      attrs: {
        "to": {
          name: item.name
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  })), _vm._v(" "), _c('a', {
    staticClass: "mdl-navigation__link mdl-cell--hide-phone",
    attrs: {
      "id": "languages-menu",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('ui-icon', {
    attrs: {
      "name": "language"
    }
  }), _vm._v("\n      " + _vm._s(_vm.currentLocale.name) + "\n    ")], 1), _vm._v(" "), _c('ul', {
    staticClass: "mdl-menu mdl-menu--bottom-right mdl-js-menu mdl-js-ripple-effect mdl-cell--hide-phone",
    attrs: {
      "for": "languages-menu"
    }
  }, _vm._l((_vm.locales), function(item) {
    return (_vm.locales) ? _c('li', {
      class: {
        'mdl-menu__item': true, 'active': item.active
      }
    }, [_c('span', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setLocale(item.locale)
        }
      }
    }, [_vm._v(" " + _vm._s(item.name))])]) : _vm._e()
  })), _vm._v(" "), _c('a', {
    staticClass: "mdl-navigation__link mdl-cell--hide-phone",
    attrs: {
      "id": "transition-names",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('ui-icon', {
    attrs: {
      "name": "build"
    }
  }), _vm._v("\n      " + _vm._s(_vm.transitionName) + "\n    ")], 1), _vm._v(" "), _c('ul', {
    staticClass: "mdl-menu mdl-menu--bottom-right mdl-js-menu mdl-js-ripple-effect mdl-cell--hide-phone",
    attrs: {
      "for": "transition-names"
    }
  }, _vm._l((_vm.transitionNames), function(item) {
    return (_vm.transitionNames) ? _c('li', {
      class: {
        'mdl-menu__item': true, 'active': item.active
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setTransitionName(item)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item) + "\n      ")]) : _vm._e()
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0501bd85!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ui/UiHeader.vue
// module id = 258
// module chunks = 2